export default {
    //
    maximize: (maximize) => ({ type: 'SIDEPANEL_MAXIMIZE', maximize }),
    toggleMaximize: () => ({ type: 'SIDEPANEL_TOGGLE_MAXIMIZE' }),
    //
    openView: () => ({ type: 'SIDEPANEL_OPEN_VIEW' }),
    closeView: () => ({ type: 'SIDEPANEL_CLOSE_VIEW' }),
    //
    showEventMap: (showEventMap = false) => ({
        type: 'SIDEPANEL_SHOW_MAP',
        showEventMap,
        maximize: app.store.getState().ui.isMobile && showEventMap,
    }),
    showFloorplan: (showFloorplan = false) => ({
        type: 'SIDEPANEL_SHOW_FLOORPLAN',
        showFloorplan,
        maximize: app.store.getState().ui.isMobile && showFloorplan,
    }),
    centerMap: (coordinates) => ({ type: 'SIDEPANEL_CENTER_MAP', coordinates }),
    //
    openExternalURL: (url, maximize) => ({ type: 'SIDEPANEL_SET_EXTERNAL_URL', url, maximize }),
    openProgramVirtualRoom: (eventId, programId, url, maximize = true) => ({
        type: 'SIDEPANEL_SET_EXTERNAL_URL',
        url,
        virtualRoom: { eventId, programId },
        maximize,
    }),
    openMeetingVirtualRoom: (eventId, meetingId, url, maximize = true) => ({
        type: 'SIDEPANEL_SET_EXTERNAL_URL',
        url,
        maximize,
        virtualRoom: { eventId, meetingId },
    }),
    closeExternalURL: () => ({ type: 'SIDEPANEL_SET_EXTERNAL_URL', url: null, maximize: false }),
    iframeNavigation: (url) => ({ type: 'SIDEPANEL_IFRAME_NAVIGATION', url }),
    //
    showWallpaper: (url) => ({ type: 'SIDEPANEL_SHOW_WALLPAPER', url }),
    //
    reset: () => ({ type: 'SIDEPANEL_RESET' }),
};
